import React, { Component } from 'react'
import PropTypes from 'prop-types'

import ErrorView from 'common/components/misc/ErrorView'

class ErrorBoundary extends Component {
  constructor(props) {
    super(props)
    this.state = { error: null, errorInfo: null }
  }

  componentDidCatch(error) {
    this.setState({
      error: error,
    })
    this.props.onError(error)
  }

  render() {
    if (this.state.errorInfo) {
      return <ErrorView error={this.state.error} />
    }
    return this.props.children
  }
}

ErrorBoundary.propTypes = {
  onError: PropTypes.func.isRequired,
}

export default ErrorBoundary

